/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AwsCredential { 
    /**
     * The temporary AWS access key
     */
    awsAccessKey: string;
    /**
     * The temporary AWS secret key
     */
    awsSecretKey: string;
    /**
     * The temporary AWS session token
     */
    awsSessionToken: string;
    /**
     * The temporary AWS credential expiration time
     */
    awsSessionExpirationTime: Date;
}
